// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Toggle_wrapper__CpWAe","input":"Toggle_input__G59Ip","label":"Toggle_label__iYM2W","disabled":"Toggle_disabled__9XFjK"};